import { render, staticRenderFns } from "./FormTextAreaInput.vue?vue&type=template&id=ebfff02e&scoped=true&"
import script from "./FormTextAreaInput.vue?vue&type=script&lang=js&"
export * from "./FormTextAreaInput.vue?vue&type=script&lang=js&"
import style0 from "./FormTextAreaInput.vue?vue&type=style&index=0&id=ebfff02e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfff02e",
  null
  
)

export default component.exports